import { uniqWith } from "lodash-es";

import { FlowVersion } from "src/api/flowTypes";
import { CaseSchemaWithMetadata } from "src/schema/schemaEditor/CaseSchemaEditor";

export type CaseTemplateDependency = {
  templateId: string;
  versionId: string;
};

/**
 * Extracts all case template dependencies from a flow version.
 * Checks both:
 * 1. Input schema (for flows that take case as input)
 * 2. Case creation nodes in the graph
 */
export const getUsedCaseTemplateVersions = (
  flowVersion: FlowVersion,
): CaseTemplateDependency[] => {
  const dependencies: CaseTemplateDependency[] = [];

  // 1. Check input schema for case template metadata
  const inputSchema = flowVersion.input_schema;
  if (inputSchema?.properties?.case) {
    const caseSchema = inputSchema.properties.case as CaseSchemaWithMetadata;
    const metadata = caseSchema._template_metadata;

    if (metadata?.templateId && metadata?.versionId) {
      dependencies.push({
        templateId: metadata.templateId,
        versionId: metadata.versionId,
      });
    }
  }

  // 2. Check case creation and update nodes in graph
  const nodes = flowVersion.graph?.nodes || [];
  nodes.forEach((node) => {
    if (
      node.type === "case_creation_node" ||
      node.type === "case_update_node"
    ) {
      const nodeMeta = node.meta;
      if (nodeMeta.template) {
        const template = nodeMeta.template;
        if (template.id && template.version_id) {
          dependencies.push({
            templateId: template.id,
            versionId: template.version_id,
          });
        }
      }
    }
  });

  return uniqWith(
    dependencies,
    (a, b) => a.templateId === b.templateId && a.versionId === b.versionId,
  );
};
